import React, { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { EmojiTitleButtonLoader } from '@confluence/emoji-title/entry-points/EmojiTitleButton.tsx';

import { Box } from '@atlaskit/primitives/compiled';

import type { EmojiButtonProps } from './titleareaContentComponentsTypes.ts';

export const EmojiButton = ({
	contentId,
	userOffline,
	isDraftLockedForEditing,
	isTitleDisabled,
	isUnpublishedDraft,
	setSelectedEmoji,
	onEmojiPickerLoaded,
	onUpdateStartEmoji,
	onUpdateEndEmoji,
	floatingToolbarButtonStyle,
	contentType,
	autoPageEmojiCohort,
	emojiTitleDiscovered,
}: EmojiButtonProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleOnMouseEnter = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'hovered',
				source: 'EmojiTitleSection',
				actionSubject: 'pageTitle',
				actionSubjectId: 'emojiButton',
				attributes: {
					element: 'div',
				},
			},
		}).fire();
	}, [createAnalyticsEvent]);

	const handleOnMouseLeave = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'not:hovered',
				source: 'EmojiTitleSection',
				actionSubject: 'pageTitle',
				actionSubjectId: 'emojiButton',
				attributes: {
					element: 'div',
				},
			},
		}).fire();
	}, [createAnalyticsEvent]);

	return (
		<Box
			testId="emoji-title-hover-button-wrapper"
			onMouseEnter={handleOnMouseEnter}
			onMouseLeave={handleOnMouseLeave}
		>
			<EmojiTitleButtonLoader
				isUnpublishedDraft={isUnpublishedDraft}
				setSelectedEmoji={setSelectedEmoji}
				onEmojiPickerLoaded={onEmojiPickerLoaded}
				disableEmoji={userOffline || !!isDraftLockedForEditing}
				contentId={contentId}
				isTitleDisabled={isTitleDisabled}
				onUpdateStartEmoji={onUpdateStartEmoji}
				onUpdateEndEmoji={onUpdateEndEmoji}
				floatingToolbarButtonStyle={floatingToolbarButtonStyle}
				contentType={contentType}
				autoPageEmojiCohort={autoPageEmojiCohort}
				emojiTitleDiscovered={emojiTitleDiscovered}
			/>
		</Box>
	);
};
